module.exports = __webpack_public_path__ + "static/media/future-tense-table-3.19bef53e.PNG";